import React from 'react';
import styles from './Person.module.scss';
import moment from 'moment';
import { adminImages, loginImages } from '../../assets/images';
import documentIcon from '../../../src/assets/images/document-icon/image.png';
import strings from '../../globalization';
import Flex from '../Flex';
import FormElement from '../FormElement';
import rectangleIcon from '../../assets/images/profile/rectangle-icon/image1@2x.png';
import Button from '../Button';

/**
 *
 * @param {Boolean} error
 * @param {Boolean} success
 * @return {JSX.Element}
 */

/**
 *
 * @param {Props} props
 * @return {JSX.Element}
 */
function ViewAgencyDetails(props) {
  console.log('details', props);
  const { companyDetails, onClick, onBlackList, onUnBlackList, roleId } = props || {};
  const { name, vehicleType, status, id } = companyDetails;
  return (
    <Flex direction="row" className={styles.mainContainer}>
      <Flex direction="column" className={styles.tabsContainer}>
        <div className={styles.imgContainer}>
          <div className={styles.imgIcon}>
            <img src={rectangleIcon} className={styles.centerIcon} alt="s" />
          </div>
          <div className={styles.nameBlock}>
            <div className={styles.name}> Name: {name}</div>
            <div className={styles.nameLabel}>Status : {status}</div>
          </div>
          {roleId !== 10 && status === 'APPROVED' ? (
            <div className={styles.blackListBtnContainer}>
              <Button
                onClick={() => {
                  onBlackList(id);
                }}
                buttonStyle="orangeBtn"
                label={'Blacklist'}
                className={styles.blackListBtn}></Button>
            </div>
          ) : null}
          {roleId !== 10 && status === 'BLACKLISTED' ? (
            <div className={styles.blackListBtnContainer}>
              <Button
                onClick={() => {
                  onUnBlackList(id);
                }}
                buttonStyle="orangeBtn"
                label={'Remove Blacklist'}
                className={styles.unBlackListBtn}></Button>
            </div>
          ) : null}
        </div>
      </Flex>
      <Flex direction="column" className={styles.dataContainer}>
        <VehicleCard onClick={onClick} agencyDetails={companyDetails} />
      </Flex>
    </Flex>
  );
}

export default ViewAgencyDetails;

const DataItem = ({ onClick, value, label, labelStyle, document }) => {
  return (
    <Flex className={styles.dataItemWrapper}>
      <div className={[styles.label, labelStyle].join(' ')}>{label} :</div>
      {document && value ? (
        <div className={styles.documentViewLink}>
          {/* <div>{value?.slice(-10)}</div> */}
          <img
            onClick={() => onClick('document-view', value)}
            className={styles.documentIcon}
            alt="."
            src={documentIcon}
          />
        </div>
      ) : (
        <div>
          {value ? (
            value
          ) : (
            <span className={styles.greyColor}>DATA NOT UPLOADED</span>
          )}
        </div>
      )}
    </Flex>
  );
};

const VehicleCard = ({ onClick, agencyDetails }) => {
  console.log('stateData...', agencyDetails);
  const formatDate = date => moment(date).format('MMM Do YYYY');

  return (
    <Flex direction="column">
      <div className={styles.headLabel}>Agency Details</div>

      <Flex>
        <div>
          <DataItem
            label={'Mobile Number. '}
            value={agencyDetails?.phoneNumber?.slice(3)}
          />
          <DataItem
            label={'Agency Name'}
            value={
              agencyDetails?.name?.length > 25
                ? agencyDetails?.name?.slice(0, 25) + '...'
                : agencyDetails?.name
            }
          />
          <DataItem
            label={'Registration Date'}
            value={formatDate(agencyDetails?.createdDate)}
          />
          <DataItem label={'GST Number'} value={agencyDetails?.gstnumber} />
          <DataItem label={'PAN Number'} value={agencyDetails?.pannumber} />
          <DataItem
            label={'Department '}
            value={agencyDetails?.department?.name}
          />{' '}
        </div>
        <div className={styles.marginLeft30}>
          <DataItem
            label={'Email Address'}
            value={
              agencyDetails?.emailAddress?.length > 25
                ? agencyDetails?.emailAddress?.slice(0, 25) + '...'
                : agencyDetails?.emailAddress
            }
          />
          <DataItem label={'Reference Id'} value={agencyDetails?.referenceId} />

          <DataItem
            label={'REGISTRATION PROOF'}
            document={true}
            onClick={onClick}
            value={agencyDetails?.companyDocuments[0]?.fileUrl}
          />
          <DataItem
            label={'GST DOCUMENT'}
            document={true}
            onClick={onClick}
            value={agencyDetails?.companyDocuments[1]?.fileUrl}
          />
          <DataItem
            label={'PAN DOCUMENT'}
            document={true}
            onClick={onClick}
            value={agencyDetails?.companyDocuments[2]?.fileUrl}
          />
          <DataItem
            label={'Business Details '}
            value={agencyDetails?.businessDetails?.name}
          />
        </div>
      </Flex>
    </Flex>
  );
};
